import { api } from "./client"; // your existing axios instance

export const scoringApi = {
  get: () => api.get("/codebase/scoring"),
  update: (payload) => api.put("/codebase/scoring", payload),
};
